import { LICENSE_SCOPE, LicenseScope } from '@saasalerts/common/shared'

import { getMeticulousReplayLicenseScope } from '@/utils/meticulous'

type DomainMapping = Record<string, LicenseScope>

const DEFAULT_MAPPING: DomainMapping = {
  kaseyamdr: LICENSE_SCOPE.KMDR,
  kaseyasiem: LICENSE_SCOPE.KSIEM,
  saasalerts: LICENSE_SCOPE.SA,
  localhost: LICENSE_SCOPE.KSIEM,
}

function parseDomainMapping(): DomainMapping {
  try {
    const raw = process.env.VITE_DOMAIN_MAPPING
    if (!raw) return DEFAULT_MAPPING
    return JSON.parse(raw) as DomainMapping
  } catch {
    return DEFAULT_MAPPING
  }
}

export function getLicenseScope(hostname: string): LicenseScope | null {
  const replayScope = getMeticulousReplayLicenseScope()
  if (replayScope) return replayScope

  const h = hostname.toLowerCase()
  const mapping = parseDomainMapping()

  for (const [domainPart, scope] of Object.entries(mapping)) {
    if (h.includes(domainPart)) return scope
  }

  return null
}
